/**
 * @desc getReport
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getReport.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getItem`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
